// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "986d5465d8435564ac6a" + ".chunk.js";
};